import React from 'react';
import ReactDOM from 'react-dom/client';
import AcpWeb from './AcpWeb';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AcpWeb />
  </React.StrictMode>
);
